'use strict';

var format = require('string-format');
var tuneInRequest = require('../tuneInRequest');

module.exports = function reports(config, apiContext) {
  var pageViewEndPoint = format('{reports}/reports/v/', config.domains);

  function sendPageView(params) {
    return tuneInRequest({
      method: 'post',
      url: pageViewEndPoint,
      params: params,
      disableRetry: true
    }, apiContext);
  }

  return {
    sendPageView: sendPageView
  };
};
//# sourceMappingURL=reports.js.map